import DownloadIcon from '@mui/icons-material/Download';
import { IconButton, Tooltip } from '@mui/material';

const DownloadFileButton = ({ href }: { href: string }) => (
  <Tooltip title="Download Import File">
    <IconButton
      aria-label="Download Import File"
      href={href}
      size="small"
      onClick={(event) => event.stopPropagation()}
    >
      <DownloadIcon fontSize="small" />
    </IconButton>
  </Tooltip>
);

export default DownloadFileButton;
